import PropTypes from 'prop-types';
import classNames from 'classnames';

import Styles from './WizardNav.module.scss';

const WizardNav = ({ items = [], selected, className, ...props }) => {
  return (
    <ul className={classNames(Styles.wizardNav, className)} {...props}>
      {items.map(({ text, ...props }, idx) => (
        <li
          key={idx}
          {...props}
          className={classNames(
            Styles.navItem,
            selected === idx && Styles.active,
            selected > idx && Styles.completed
          )}>
          {text}
        </li>
      ))}
    </ul>
  );
};

WizardNav.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.number,
  items: PropTypes.array,
};

export default WizardNav;
